import gql from 'graphql-tag';

export const GET_APP_NAME = gql`
	query app($id: ID!) {
		app(id: $id) {
			name
		}
	}
`;
